import humps from 'humps'

import { stadiumApi } from 'store/stadiumApi'
import {
  TPosAccountRoleResponse,
  TDeletePosAccountRole,
  TCreatePosAccountRole,
} from 'types/posAccounts'

const employeeRoles = stadiumApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeRoles: builder.query<TPosAccountRoleResponse, void>({
      query: () => '/operator/employee_roles',
      providesTags: (result) =>
        result?.employeeRoles
          ? [
              ...result.employeeRoles.map(({ uuid }) => ({
                type: 'EmployeeRoles' as const,
                uuid,
              })),
            ]
          : [
              {
                type: 'EmployeeRoles',
                uuid: 'LIST',
              },
            ],
    }),
    getPosAccountRole: builder.query<TPosAccountRoleResponse, number>({
      query: (attendantId) => `/operator/employee_roles?employee_id=${attendantId}`,
      providesTags: (result) =>
        result?.employeeRoles
          ? [{ type: 'EmployeeRoles', uuid: result?.employeeRoles?.[0]?.uuid }]
          : [{ type: 'EmployeeRoles', uuid: 'Item' }],
    }),
    deletePosAccountRole: builder.mutation<TPosAccountRoleResponse, TDeletePosAccountRole>({
      query: ({ uuid }) => ({
        url: `/operator/employee_roles/${uuid}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result) =>
        result?.employeeRoles
          ? [{ type: 'EmployeeRoles', uuid: result?.employeeRoles?.[0]?.uuid }]
          : [{ type: 'EmployeeRoles', uuid: 'LIST' }],
    }),
    createPosAccountRole: builder.mutation<TPosAccountRoleResponse, TCreatePosAccountRole>({
      query: ({ role, type, employee_id }) => ({
        url: `/operator/employee_roles`,
        method: 'POST',
        body: {
          employee_roles: [humps.decamelizeKeys({ role, type, employee_id })],
        },
      }),
      invalidatesTags: (result) =>
        result?.employeeRoles
          ? [{ type: 'EmployeeRoles', uuid: result?.employeeRoles?.[0].uuid }]
          : [{ type: 'EmployeeRoles', uuid: 'LIST' }],
    }),
  }),
})

export const {
  useGetEmployeeRolesQuery,
  useGetPosAccountRoleQuery,
  useDeletePosAccountRoleMutation,
  useCreatePosAccountRoleMutation,
} = employeeRoles
